import { render, staticRenderFns } from "./painelgerirturmas.vue?vue&type=template&id=badd95d4&"
import script from "./painelgerirturmas.vue?vue&type=script&lang=js&"
export * from "./painelgerirturmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports